import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TdMarkdownComponent } from './markdown.component';
export class QuiverMarkdownModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    TdMarkdownComponent,
  ],
  exports: [
    TdMarkdownComponent,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverMarkdownModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverMarkdownModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverMarkdownModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
